import { render } from "./PpcBAMaxPotentialPercentCell.vue?vue&type=template&id=35252ec0&scoped=true"
import script from "./PpcBAMaxPotentialPercentCell.vue?vue&type=script&lang=js"
export * from "./PpcBAMaxPotentialPercentCell.vue?vue&type=script&lang=js"

import "./PpcBAMaxPotentialPercentCell.vue?vue&type=style&index=0&id=35252ec0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35252ec0"]])

export default __exports__